import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "type", "variant", "onClick", "onMouseDown", "eventData", "width", "testId"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as React from 'react';
import { useContext } from 'react';
import { onlyText } from 'react-children-utilities';
import { AnalyticsContext, AnalyticsLocationConsumer, EventDataObject, trackEvent } from 'latitude-analytics';
import { BUTTON_STYLE, BUTTON_TYPE } from '@latitude/core/utils/constants';
import { StyledButton } from './Button.styled';
export var Button = function Button(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? BUTTON_TYPE.BUTTON : _ref$type,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? BUTTON_STYLE.PRIMARY : _ref$variant,
      onClick = _ref.onClick,
      onMouseDown = _ref.onMouseDown,
      _ref$eventData = _ref.eventData,
      eventData = _ref$eventData === void 0 ? {} : _ref$eventData,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'auto' : _ref$width,
      testId = _ref.testId,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useContext = useContext(AnalyticsContext),
      analytics = _useContext[0];

  var handleOnClick = function handleOnClick(event, location) {
    trackEvent(analytics, _objectSpread({
      category: 'button-link',
      action: 'internal-link',
      label: onlyText(children),
      location: location
    }, eventData));

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, null, function (location) {
    return /*#__PURE__*/React.createElement(StyledButton, Object.assign({
      type: type,
      variant: variant,
      onClick: function onClick(event) {
        return handleOnClick(event, location);
      },
      onMouseDown: onMouseDown,
      width: width,
      "data-test-id": testId
    }, rest), children);
  });
};
export default Button;